import { Component, Input, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { MENU_ADMIN, MENU_MEDICO, MENU_ENFERMERA, MENU_SUPERVISOR, MENU_ADMIN_N2, MENU_ADMIN_N1 } from 'src/app/shared/constantes/menus';
import { ROLE, NIVEL } from 'src/app/shared/constantes/pages-usuarios';
@Component({
  selector: 'app-mainavbar',
  templateUrl: './mainavbar.component.html',
  styleUrls: ['./mainavbar.component.scss']
})
export class MainavbarComponent implements OnInit {
  @Input() idRol!: number;
  @Input() idNivel!: number;
  items: MenuItem[] = [];
  usuario!: any | null;
  constructor(private auth: AuthService) {

    this.usuario = {
      label: this.auth.getUsuario?.alias,
      icon: 'pi pi-fw pi-user',
      items: [
        /*
          {
            label: 'Perfil',
            icon: 'pi pi-fw pi-user',
            routerLink: ['/usuario/perfil']
          },
          */
        {
          label: 'Cerrar Sesion',
          icon: 'pi pi-fw pi-power-off',
          command: () => { this.auth.cerrar(); }
        },
      ]
    }
  }
  ngOnInit(): void {
    if (this.idRol == ROLE.ADMINISTRADOR_ROOT || this.idRol == ROLE.ADMINISTRADOR && this.idNivel == NIVEL.N0) this.items.push(...MENU_ADMIN);
    if (this.idRol == ROLE.ADMINISTRADOR_ROOT || this.idRol == ROLE.ADMINISTRADOR && this.idNivel == NIVEL.N1) this.items.push(...MENU_ADMIN_N1);
    if (this.idRol == ROLE.ADMINISTRADOR_ROOT || this.idRol == ROLE.ADMINISTRADOR && this.idNivel == NIVEL.N2) this.items.push(...MENU_ADMIN_N2);
    if (this.idRol == ROLE.MEDICO) this.items.push(...MENU_MEDICO);
    if (this.idRol == ROLE.ENFERMERA) this.items.push(...MENU_ENFERMERA);
    if (this.idRol == ROLE.SUPERVISOR) this.items.push(...MENU_SUPERVISOR);

    if (this.usuario != null) this.items.push(this.usuario);
  }
}
